// extracted by mini-css-extract-plugin
export default {"mantine-mkghez":"carouselCompoStyle_mantine-mkghez__VvZ7I","mantine-2yup0d":"carouselCompoStyle_mantine-2yup0d__srTWo"};